import RequestBase from './RequestBase';

export default class LatestDecisionRequest extends RequestBase {
    constructor(customerId) {
        super();
        this._url = '/customers/{customerId}/CreditDecision';
        this.method = 'GET';
        this.customerId = customerId;
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Decisions.js